import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MoreReviewsButton } from '../../components/MoreReviewsButton';
import { getHasMore } from '../../selectors/pagination';
import { reviewsPaginationRequestAction } from '../../actions/pagination';
import { TThunkDispatch } from '../../types/redux';

export function MoreReviewsButtonContainer() {
  const hasMore = useSelector(getHasMore);
  const dispatch = useDispatch<TThunkDispatch>();

  const onClick = React.useCallback(() => {
    dispatch(reviewsPaginationRequestAction());
  }, []);

  if (!hasMore) {
    return null;
  }

  return <MoreReviewsButton onClick={onClick} />;
}
